import {
  FAQS,
  AnalyticsHeader,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
  REGISTRATION_TERMS_AND_CONDITIONS,
} from "./helper";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

import BannerImage from "public/images/utahjazz/Banner_AttendPage.png";
import MobileBannerImage from "public/images/utahjazz/GFX_AttendPage.png";

export const utahjazz_pass: TTeamConfig = {
  TEAM_SCHEMA: "utahjazz_pass",
  TEAM_FULL_NAME: "Utah Hockey Club",
  BROWSER_TITLE: "Jazz Fan Pass",
  CLIENT_ID: "NDYxNzQ3MTB8MTcyOTAxMzI5Ny4zNjU0NTg3",
  VENDOR: "SEATGEEK",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#3E2680",
    COLORS_SECONDARY: "#3E2680",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
    },
    ANALYTICS_HEADER: AnalyticsHeader,
    IS_INTERCOM_ENABLED: true,
    IS_CROWD_HANDLER_ENABLED: true,
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    PASS: {
      ADD_SERVICE_FEE_TO_PRICE: true,
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SHOW_FAQ_BUTTON: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
    ADD_ON: {
      ADD_SERVICE_FEE_TO_PRICE: true,
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTRATION_TERMS_AND_CONDITIONS />,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/Utahjazz%20Assets/utah-jazz-logo.png",
    LANDING_PAGE_STATIC_BANNER_URL: BannerImage.src,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: MobileBannerImage.src,
    FOOTER_LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA 2024-25/jazz-v3-assets/JAZ2425_Primary_RGB_White.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA%202024-25/jazz-v3-assets/2N5A2951.jpeg",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PRE_PURCHASE_FAQS: FAQS,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
